// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"1ce0a846","84":"4e501f62","137":"1d2f7141","199":"12a53f50","231":"42e428fc","320":"78703aed","398":"7ee2bef2","638":"3558990a","675":"6a1d2a4e","759":"e891b93a","788":"87371896","854":"f583195e","876":"c661fe09","896":"9eff59c9"}[chunkId] + ".chunk.js";
};